import { useState, useRef, useMemo, useCallback, useEffect, isValidElement, Children, cloneElement } from 'react';
import '@dynamic-labs/multi-wallet';
import '@dynamic-labs/sdk-api';
import '../../config/ApiEndpoint.js';
import '../../shared/logger.js';
import '@dynamic-labs/iconic';
import 'react/jsx-runtime';
import '../../context/ViewContext/ViewContext.js';
import '../../utils/constants/colors.js';
import '../../shared/consts/index.js';
import '../../context/DynamicContext/DynamicContext.js';
import '../../context/ErrorContext/ErrorContext.js';
import { usePrevious } from '../../utils/hooks/usePrevious/usePrevious.js';
import 'react-dom';
import '../ShadowDOM/ShadowDOM.js';
import '../../context/ThemeContext/ThemeContext.js';
import 'react-focus-lock';
import '../Transition/ZoomTransition/ZoomTransition.js';
import '../Transition/SlideInUpTransition/SlideInUpTransition.js';
import '../Transition/OpacityTransition/OpacityTransition.js';
import '../IconButton/IconButton.js';
import 'ethers';
import { useForceUpdate } from '../../utils/hooks/useForceUpdate/useForceUpdate.js';
import '../../context/MockContext/MockContext.js';
import '../../context/CaptchaContext/CaptchaContext.js';
import '../../utils/hooks/useUserUpdateRequest/useUserUpdateRequest.js';

const AnimatePresence = ({ children, animationComponent, }) => {
    const [isPresent, setIsPresent] = useState(true);
    const forceRerender = useForceUpdate();
    const childrenRef = useRef(null);
    const isChildrenPresent = useMemo(() => Boolean(children), [children]);
    const prevIsChildrenPresent = usePrevious(isChildrenPresent);
    const onAnimationEnd = useCallback(() => {
        childrenRef.current = null;
        forceRerender();
    }, [forceRerender]);
    useEffect(() => {
        if (isValidElement(children)) {
            childrenRef.current = Children.map(children, (child) => cloneElement(child));
        }
    }, [children]);
    useEffect(() => {
        if (isChildrenPresent && !prevIsChildrenPresent) {
            setIsPresent(true);
        }
        if (prevIsChildrenPresent && !isChildrenPresent) {
            setIsPresent(false);
        }
    }, [isChildrenPresent, prevIsChildrenPresent]);
    return cloneElement(animationComponent, {
        children: children || childrenRef.current,
        isPresent,
        onAnimationEnd,
    });
};

export { AnimatePresence };
